import { Modal } from '@mui/material';
import { CloseButton, WrapperModal } from '../../../../styled-components';
import { Icon } from '@iconify/react';
import styled from 'styled-components';
import axios from 'axios';
import { useState } from 'react';
import SimpleLoading from '../../../common/SimpleLoading';
import { useDispatch } from 'react-redux';
import { documentsActions } from '../../../../redux/actions';

const DocumentReviewDataModal = (props) => {
    const { open, handleCloseModal, passportData, id_documento } = props;

    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();

    const handleApproval = async (approved) => {
        setLoading(true);
        try {
            const body = {
                approved,
                passport_data: passportData,
            };

            const response = await axios.patch(
                `${process.env.REACT_APP_SISAPI}/v2/acropolis/student_document/passport/${id_documento}`,
                body
            );
            if (response.status === 200) {
                dispatch(documentsActions.getDocumentsRequest());
                handleCloseModal();
            }
        } catch (error) {
            console.error('Error en la petición:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            onClose={() => {
                handleApproval(false);
            }}
            open={open}
        >
            <WrapperModal
                widthModal={'600px'}
                maxHeightModal="90vh"
                gapModal="1rem"
                topModal="50%"
                leftModal="50%"
            >
                <CloseButton
                    onClick={() => {
                        handleApproval(false);
                    }}
                >
                    <Icon icon="iconoir:cancel" width="24px" height="24px" />
                </CloseButton>

                <Title>Revisión de Datos del Pasaporte</Title>

                {passportData && (
                    <DataContainer>
                        <DataField>
                            <Label>Nombre:</Label>
                            <Value>{passportData.given_names || 'N/A'}</Value>
                        </DataField>

                        <DataField>
                            <Label>Apellido:</Label>
                            <Value>{passportData.last_name || 'N/A'}</Value>
                        </DataField>

                        <DataField>
                            <Label>Fecha de nacimiento:</Label>
                            <Value>{passportData.date_of_birth || 'N/A'}</Value>
                        </DataField>

                        <DataField>
                            <Label>Nacionalidad:</Label>
                            <Value>{passportData.nationality || 'N/A'}</Value>
                        </DataField>

                        <DataField>
                            <Label>Sexo:</Label>
                            <Value>{passportData.sex || 'N/A'}</Value>
                        </DataField>

                        <DataField>
                            <Label>Número de cédula:</Label>
                            <Value>
                                {passportData.national_id_number || 'N/A'}
                            </Value>
                        </DataField>

                        <DataField>
                            <Label>Número de pasaporte:</Label>
                            <Value>
                                {passportData.passport_number || 'N/A'}
                            </Value>
                        </DataField>

                        <DataField>
                            <Label>Fecha de expiración:</Label>
                            <Value>
                                {passportData.expiration_date || 'N/A'}
                            </Value>
                        </DataField>

                        <Message>
                            Por favor, revise cuidadosamente la información
                            extraída de su pasaporte. ¿Los datos mostrados son
                            correctos?
                        </Message>

                        {loading ? (
                            <SimpleLoading />
                        ) : (
                            <ButtonContainer>
                                <ErrorButton
                                    onClick={() => handleApproval(false)}
                                >
                                    No, tiene errores
                                </ErrorButton>
                                <SuccessButton
                                    onClick={() => handleApproval(true)}
                                >
                                    Sí, son correctos
                                </SuccessButton>
                            </ButtonContainer>
                        )}
                    </DataContainer>
                )}
            </WrapperModal>
        </Modal>
    );
};

export default DocumentReviewDataModal;

const DataContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
`;

const DataField = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
`;

const Label = styled.span`
    font-weight: 600;
    font-size: 0.8rem;
    color: #555;
`;

const Value = styled.span`
    font-size: 1rem;
    color: #000;
    padding: 0.5rem;
    background-color: #f5f5f5;
    border-radius: 4px;
    border: 1px solid #ddd;
`;

const Message = styled.p`
    text-align: center;
    font-size: 1rem;
    margin: 1rem 0 1rem 0;
    color: #333;
`;

const ButtonContainer = styled.div`
    display: flex;
    gap: 1rem;
    justify-content: center;
    margin-top: 0.5rem;
`;

const Button = styled.button`
    padding: 0.75rem 1.5rem;
    border-radius: 4px;
    border: none;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
        opacity: 0.8;
    }
`;

const ErrorButton = styled(Button)`
    background-color: #fff;
    color: #b31d15;
    outline: 2px solid #b31d15;
    border-radius: 20px;
`;

const SuccessButton = styled(Button)`
    background-color: #b31d15;
    color: white;
    border-radius: 20px;
`;

const Title = styled.h2`
    text-align: center;
    color: #b31d15;
    font-size: 1.2rem;
`;
